import { dictIdDelivery } from '../../consts';

export const PLACEHOLDER_IMAGE =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAPFBMVEXu7u62trbx8fHPz8/t7e2zs7O8vLy5ubnl5eWrq6vc3Nzq6urZ2dnh4eHV1dW6urrHx8fBwcHKysqlpaXy5cTEAAAEF0lEQVR4nO3bjXKkKBQFYLj8CAIK5v3fdS/Y9mi3md1UZavFOt9UTTpgujwBQaEjBAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEDH6N2nT+l3TfaNulNEGo18Y+KnT+sXUXkPKGW5USOGs4BShk+f1++JJ52Uu+l0m0akfN6GN+im66RA7jygNK7veYNcnBo1fJNQDmo9IrouQ2az+S4gt+ImdzjqlLMp0Pz5/6XGfvp8f4qm9xhmVimwNNmTys4GVv0+x5uStiGFKO1a+NGktq+EQtjXgGo3ZOpdG5tlaiPR0HvC+BJgu1U1C7eo6T+heQQkEYJ4vHzc6PD1F/pPaHI7fXKZi+2yzn60tLrBhdx/Qqlbmdpmi6WlCcN+pOk7YXvYpeU5fj4iqv2k0XVC48TLU/B6XYbbJGz3K/rQqi0PDXdJ2MYZd7iPMXW0OTxV9ZzQ1MuQjk/BrZvS/kLsOmEdV15uVNttKKm7tGEbOceTNlxuknBdrTiuRpn6PHi4Pe864VAnfMr7RmyhSd4loRlfG7HNkCLdZj5cb0t3U/464R+X4LpOKE1qiRw/2/M/Y9db7yTvk1DOayEllbNKdHZI5wkfj09itzx6HHm6T8gR9SEB6ZeA3SeUxnLn1FttuyRvlrA247aIz8/678uJN0hYB9FlinFa7NmacG8Jz/dE12X885re1kvP1rz/qrc17/pI/6OIZtb//p4XE6z5gdLh3hPfwEzqP5pSb1304eRTQt/49JkCAAAAAEBftHt/0D0rq9zFHhmfH1n7U0LHkrY749uC/lnZ/r3aMet+zjXoGEaVRN18UfG58hvVWBdGp6kGiDoqRy76aWxV9S8RjmXCRdLCjfwjiotDNOo6f66g/TBYHwUVX8y6cSaCNPwdTd5yDWkvZ+vHcfBz4apZSSv2ZbWfpi/H71Bo9Hnx0Q1+3Xe8BG0yUbGkfOCv87pzZohCCF+RKPog/EJkCyd1RLnwU70f92X1XWjO/DoJ7p2csvXSy3RTXU9GzWTr/svo2wb29gGM+pqb1yc+whJfc1w1lFI43q6s4t+EiIac59rC7Xmp69AkUROW0hK2Pe0tIX9DX9xe9YgtYR6Z25e1d+HIVnHCWKv1JROO3PXCY8NX8XmnxD1R6MwxazJOo/2oSZlAgct3Ze2CIyVr+8vMv5lIwkx0neuwtYbkPueNL4+yzK8XSsZ749r1RYvlq9Rz3FqV9b5snfoCD008lBqu5mEre3+dGbG1Qe2PIYXnVNdek3CtD9Zz1aFO7+552KGsvY1v00b9kdrFt+IrOblhOfvyTRlN5v85rasYzdfrh8FvJox9/m3QD9w9HwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAANzJP/MdJGqyWhqXAAAAAElFTkSuQmCC';

export const getCurrencySymbol = currency => {
  if (currency === 'EUR') return '€';
  if (currency === 'LIB') return '£';
  return '$';
};

export const wholesaleOf = (product, currency) => {
  if (currency === 'EUR') return product.wholesale_eur;
  if (currency === 'LIB') return product.wholesale_lib;
  return product.wholesale_usd;
};

export const msrpOf = (product, currency) => {
  if (currency === 'EUR') return product.msr_price_eur;
  if (currency === 'LIB') return product.msr_price_lib;
  return product.msr_price_usd;
};

const SHOE_SIZES = [
  '5',
  '6',
  '6 1/2',
  '7',
  '7 1/2',
  '8',
  '8 1/2',
  '9',
  '9 1/2',
  '10',
  '11',
];

export const sortSizes = sizes =>
  sizes.length === 11 && sizes[0] === '5' ? SHOE_SIZES : sizes;

export const groupByDelivery = products => {
  const groups = { d1: [], d2: [], d3: [], d4: [] };
  products.forEach(product => {
    if (product.delivery_id === dictIdDelivery[1]) groups.d1.push(product);
    else if (product.delivery_id === dictIdDelivery[2]) groups.d2.push(product);
    else if (product.delivery_id === dictIdDelivery[3]) groups.d3.push(product);
    else if (product.delivery_id === dictIdDelivery[4]) groups.d4.push(product);
  });
  return groups;
};

export const productQuantity = product =>
  (product.cartInfo || []).reduce(
    (sum, item) => sum + Number(item.quantity || 0),
    0
  );

export const productTotal = (product, currency) =>
  productQuantity(product) * Number(wholesaleOf(product, currency) || 0);

const CATEGORY_LABEL_OVERRIDES = {
  SKIRT: 'Skirts',
  KNITWEAR: 'Sweaters',
  'TOPS AND BLOUSES': 'Tops & Blouses',
};

const humanizeCategory = key =>
  key
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

export const labelForCategory = key =>
  CATEGORY_LABEL_OVERRIDES[key] || humanizeCategory(key);

export const summarizeDelivery = (products, currency) => {
  const byKey = {};
  let total = 0;
  products.forEach(product => {
    const productPrice = productTotal(product, currency);
    total += productPrice;
    const key = product.category_name;
    if (!key) return;
    if (!byKey[key]) {
      byKey[key] = { key, label: labelForCategory(key), qtd: 0, price: 0 };
    }
    byKey[key].qtd += 1;
    byKey[key].price += productPrice;
  });
  const categories = Object.values(byKey).sort((a, b) =>
    a.label.localeCompare(b.label)
  );
  return { total, categories };
};

export const findEmptyProducts = products =>
  products
    .filter(
      product =>
        !(product.cartInfo || []).some(item => Number(item.quantity) > 0)
    )
    .map(product => product.style_code);
